import Chart from "react-apexcharts";

const PopularTestsChart = ({ data }) => {
  if (!data || data.length === 0) {
    return <div className="text-center text-muted">No data available</div>;
  }

  const chartData = {
    series: [{
      data: data.slice(0, 6).map(test => test.TOTAL_COUNT)
    }],
    options: {
      chart: {
        type: 'bar',
        toolbar: { show: false }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          distributed: true,
          barHeight: '70%'
        }
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => val
      },
      xaxis: {
        categories: data.slice(0, 6).map(test => test.TESTNAME)
      },
      colors: ['#0d6efd', '#198754', '#ffc107', '#dc3545', '#6f42c1', '#fd7e14'],
      legend: { show: false },
      tooltip: {
        y: {
          formatter: (val) => `${val} tests`
        }
      }
    }
  };

  return <Chart options={chartData.options} series={chartData.series} type="bar" height={300} />;
};

export default PopularTestsChart;